import { getMomentTz, MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { DelayByShift } from "../models/DelayByShift";

const moment = getMomentTz();

type getDelaysProps = {
	startDate: Date;
	endDate: Date;
	delayAreaAssetId?: number | null;
	includeMicrodelays: boolean;
	shift?: string;
	crew?: string;
	delayCodeId?: number | null;
	delayCategoryId?: number | null;
	sectionId?: number | null;
};

export const getDelays = async (
	params: getDelaysProps,
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "StartDate", value: params.startDate.toISOString() },
		{ name: "EndDate", value: params.endDate.toISOString() },
		{ name: "DelayAreaAssetId", value: params.delayAreaAssetId ?? null },
		{
			name: "Shift",
			value: params.shift === "all" ? null : (params.shift ?? null),
		},
		{
			name: "Crew",
			value: params.crew === "all" ? null : (params.crew ?? null),
		},
		{ name: "IncludeMicrodelays", value: params.includeMicrodelays },
		{ name: "DelayCodeId", value: params.delayCodeId ?? null },
		{ name: "DelayCategoryId", value: params.delayCategoryId ?? null },
		{ name: "SectionId", value: params.sectionId ?? null },
	];

	const resp = await apiService.callV2("[DEL].[GetDelays]", parameters, signal);

	if (resp.ok) {
		let rows = get(resp, "data.tables[0].rows", []) as DelayByShift[];
		rows = rows.map((row) => ({
			...row,
			Start: row.Start ? moment(row.Start).toDate() : null,
			End: row.End ? moment(row.End).toDate() : null,
		}));

		return get(resp, "data.tables[0].rows", []) as DelayByShift[];
	} else {
		throw new Error(resp.message || "Error fetching delays");
	}
};

export const getShifts = async (signal?: AbortSignal) => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2("[MES].[GetShiftsAndCrews]", [], signal);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as String[];
	} else {
		throw new Error(resp.message || "Error fetching shifts");
	}
};

export const getCrews = async (signal?: AbortSignal) => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2("[MES].[GetShiftsAndCrews]", [], signal);

	if (resp.ok) {
		return get(resp, "data.tables[1].rows", []) as String[];
	} else {
		throw new Error(resp.message || "Error fetching crews");
	}
};
